module.exports = __webpack_public_path__ + "static/media/clock-icon.43da0644.png";